import * as Sentry from '@sentry/nextjs';

export const setUserCookieToSEntry = (req) => {
  if (req && req.cookies && req.cookies.filmnetState && typeof req.cookies.filmnetState === 'string') {
    const user = JSON.parse(req.cookies.filmnetState);
    Sentry.setUser({ id: user?.id, username: String(user?.msisdn) });
  }
};

export const setCookie = (c_name: string, value: any) => {
  document.cookie = `${c_name}=${JSON.stringify(value || null)}`;
};

export const getCookie = () => {
  return document.cookie?.split('; ');
};

export const deleteCookie = (c_name: string) => {
  setCookie(c_name, '');
};

export const ga4Variables = () => {
  const user_pseudo_id = document.cookie.match(/_ga=GA\d+\.\d+\.(\d+\.\d+)/)?.[1];
  const session_id = document.cookie.match(/_ga_[^=]*=GS\d+\.\d+\.s(\d+)/)?.[1];
  return { user_pseudo_id, session_id };
};

export const ga4event = (eventName) => {
  const { user_pseudo_id, session_id } = ga4Variables();
  if (user_pseudo_id && session_id) {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: eventName,
      platform: 'web',
      user_pseudo_id,
      session_id,
    });
  }
};
